<template>
  <div>
  <div class="columns">
    <div class="column is-2">
      <b-field label="Schlüssellänge">
        <b-input v-model.number="keylen" />
      </b-field>
    </div>
    <div class="column is-5">
      <b-field label="Schlüsseeltext">
        <b-input v-model.trim="text" type="textarea" custom-class="is-uppercase" />
      </b-field>
    </div>
    <div class="column is-5" style="word-wrap:break-word;word-break:break-all;">
      <b-field label="Aufgeteilter Text">
      <div>
        <span v-for="(letter, i) in coloredLetters" :key="'letter-' + i"
              :style="{color: letter.color}">{{ letter.letter }}</span>
      </div>
      </b-field>
    </div>
  </div>
  <template v-if="textGroups !== null">
    <table>
      <tr v-for="(group, i) in textGroups" :key="'group-' + i" :style="{color: group.color}">
        <th style="width:100px">Gruppe {{ i + 1 }}:</th>
        <td>{{ group.letters }}</td>
      </tr>
    </table>
  </template>
  </div>
</template>

<script>
const colors = ['#F0A3FF', '#0075DC', '#993F00', '#4C005C', '#005C31', '#FFCC99',
                '#8F7C00', '#C20088', '#FFA405', '#FF5005', '#5EF1F2', '#E0FF66',
                '#003380', '#740AFF', '#990000', '#FFA8BB']
const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
                  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']


export default {
  data () {
    return {
      keylen: 0,
      text: ''
    }
  },
  computed: {
    textGroups() {
      let text = this.text.toUpperCase()
      if (this.keylen === 0) {
        return null
      }
      let groups = []
      for (let i = 0; i < this.keylen; i++) {
        groups.push({
          color: colors[i % colors.length],
          letters: []
        })
      }
      let j = 0;
      for (let i = 0; i < text.length; i++) {
        let letter = text[i]
        if (alphabet.indexOf(letter) !== -1) {
          groups[j % this.keylen].letters.push(letter);
          j++
        }
      }
      groups.forEach(function(group) {
        group['letters'] = group['letters'].join('')
      });
      return groups
    },
    coloredLetters() {
      let result = []
      let text = this.text.toUpperCase()
      let j = 0;
      for (let i = 0; i < text.length; i++) {
        let color = ''
        let letter = text[i]
        if (alphabet.indexOf(letter) !== -1) {
          color = colors[j % this.keylen]
          j++
        } else {
          color = '#000'
        }
        result.push({
          "letter": letter,
          "color": color
        })
      }
      return result
    }
  }
}
</script>
